<template>
  <div id="footer_bar">
    <div
      class="footer_content"
      :style="{ 'justify-content': shrink ? 'center' : 'space-between' }"
    >
      <div class="left" :style="{ 'align-items': shrink ? 'center' : '' }">
        <div class="icon">
          <img
            src="@/assets/logo_band.png"
            alt="ALC(Air & Liquid Cooling Technology Limited (HK))"
            @click="router.push('/')"
          />
        </div>
      </div>
      <div class="assets" v-if="!shrink">
        <div class="label">{{ $t("footer.SOLUTION") }}</div>
        <div class="option" @click="onJumpTo(routeHash.AIR_TO_LIQUID_COOLING)">{{ $t("footer.WIND_TO_LIQUID") }}</div>
        <div class="option" @click="onJumpTo(routeHash.SYSTEMIC_LIQUID_COOLING)">{{ $t("footer.LIQUID_COOLING") }}</div>
        <div class="option" @click="onJumpTo(routeHash.RDHX_AIR_COOLED)">{{ $t("footer.LIQUID_COOLING_REAR_DOOR") }}</div>
      </div>
      <div class="assets" v-if="!shrink">
        <div class="label">{{ $t("footer.SERVICE") }}</div>
        <div class="option" @click="onJumpTo(routeHash.IDC_LIQUID_COOLING)">{{ $t("footer.DATA_CENTER") }}</div>
        <div class="option" @click="onJumpTo(routeHash.AIGC_INFRASTRUCTURE)">{{ $t("footer.COMPUTATIONAL_EQUIPMENT") }}</div>
      </div>
      <div class="assets" v-if="!shrink">
        <div class="label">{{ $t("footer.PRODUCT") }}</div>
        <div class="option" @click="onJumpTo(routeHash.L2L_PRODUCT)">{{ $t("product.L2L_NAV") }}</div>
        <div class="option" @click="onJumpTo(routeHash.L2A_PRODUCT)">{{ $t("product.L2A_NAV") }}</div>
        <div class="option" @click="onJumpTo(routeHash.RDHx_PRODUCT)">{{ $t("product.RDHx_NAV") }}</div>
        <div class="option" @click="onJumpTo(routeHash.OTHERS_PRODUCT)">{{ $t("product.OTHERS_NAV") }}</div>
      </div>
      <div class="assets" v-if="!shrink">
        <div class="label">{{ $t("footer.ABOUT_US") }}</div>
        <div class="option" @click="onJumpTo(routeHash.CONTACT_US)">{{ $t("footer.CONTACT_US") }}</div>
      </div>
    </div>
  </div>
  <div class="reverse" :style="{ 'text-align': shrink ? 'center' : 'left' }">
    <div class="reverse_content">
      <span>© 2024 ALC. All rights reserved.</span>
      <!-- <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024248251号</a> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import provide_key from "@/constant/provide_key";
import { inject, nextTick } from "vue";
import routeHash from '@/constant/router_hash'
import { useRouter } from 'vue-router'
import Mitt from "@/utils/mitt";

const router = useRouter()

const shrink: boolean | undefined = inject(provide_key.SHRINK);

const onJumpTo = (hash: any) => {
  setTimeout(() => Mitt.emit(hash), 0)
  switch(hash) {
    case routeHash.AIR_TO_LIQUID_COOLING:
    case routeHash.SYSTEMIC_LIQUID_COOLING:
    case routeHash.RDHX_AIR_COOLED:
      router.push({ path: "/solution" })
      return;
    case routeHash.IDC_LIQUID_COOLING:
    case routeHash.AIGC_INFRASTRUCTURE:
      router.push({ path: "/service" })
      return;
    case routeHash.L2A_PRODUCT:
    case routeHash.L2L_PRODUCT:
    case routeHash.RDHx_PRODUCT:
    case routeHash.OTHERS_PRODUCT:
      router.push({ path: "/product"})
      return;
    case routeHash.CONTACT_US:
      router.push({ path: "/company" })
      return;
    default: return
  }
}
</script>

<style lang="less" scoped>
#footer_bar {
  background: #f1f1f1;
  width: 100%;
  border-top: 1px solid #e3e3e3;

  .footer_content {
    display: flex;
    gap: 2rem;
    max-width: var(--view-max-width);
    margin: 0 auto;
    padding: 1rem;

    .description {
      display: flex;
      flex-direction: column;
      line-height: 20px;
    }

    .left {
      display: flex;
      flex-direction: column;
      color: #4e4e4e;
      font-size: 0.8rem;
      justify-content: center;
      align-items: center;

      .icon {
        cursor: pointer;
        width: 9rem;
        overflow-y: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }

    .assets {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      color: #4e4e4e;

      .label {
        font-size: 1rem;
        white-space: nowrap;
      }

      .option {
        font-size: 0.8rem;
        line-height: 1.2rem;
        white-space: nowrap;
        cursor: pointer;

        &:hover {
          color: #002FA5;
        }
      }
    }
  }
}

.reverse {
  color: #fff;
  background: #13122f;
  font-size: 0.8rem;

  &_content {
    margin: 0 auto;
    padding: 0 1rem;
    text-align: center;

    a {
      color: #fff;
      font-size: 0.8rem;
      margin: 1rem auto;
      max-width: var(--view-max-width);
      padding: 0 1rem;
    }
  }
}
</style>